import { render } from "./AdminPanelSetup.vue?vue&type=template&id=69d8309d&lang=true"
import script from "./AdminPanelSetup.vue?vue&type=script&lang=js"
export * from "./AdminPanelSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__